module.exports = __webpack_public_path__ + "img/feature_jy.41bdbcbf.gif";